import React, { useEffect, useState } from 'react';
import {
  // Card,
  Checkbox,
  Col,
  Collapse,
  Input,
  InputNumber,
  Row,
  Typography,
} from 'antd';
import { useDispatch, useSelector } from 'react-redux';
import {
  updateCabinsDepartureEditOrder,
  updateAddonsDepartureEditOrder,
} from '../../../redux/actions/EditOrderAction';
import _ from 'lodash';
// import dayjs from 'dayjs';
import useTime from '../../../hooks/useTime';
import IntlMessage from '../../../components/IntlMessage';

const { Text, Title } = Typography;
const { TextArea } = Input;

function roundToThousands(number) {
  return Math.round(number / 1000) * 1000;
}

const Departure = (props) => {
  const searchValues = useSelector((state) => state.editOrder.searchValues);
  const departureOrder = useSelector((state) => state.editOrder.departure);
  // states
  const { searchData, customer } = props;
  const [searchDepartureItems, setDepartureSearchItems] = useState([]);
  const [cabinsDepartureChecked, setCabinsDepartureChecked] = useState([]);
  const [addonsDepartureChecked, setAddonsDepartureChecked] = useState([]);
  const [activeDeparture, setActiveDeparture] = useState([
    departureOrder?.cabins[0]?.hop_id,
  ]);
  const [isChangeActive, setIsChangeActive] = useState(false);
  const [currentRouteId, setCurrentRouteId] = useState(
    departureOrder?.cabins[0]?.hop_id
  );
  const { convertToAnyTimezone } = useTime();

  // side effects
  useEffect(() => {
    const route = _.find(searchData, {
      id: departureOrder?.cabins[0]?.hop_id,
    });
    // console.log('route: ', route);
    if (route) {
      const cabins = route?.cabins;
      const addons = route?.hop_addons;
      if (Array.isArray(cabins)) {
        let cabinChecked = [];
        cabins.forEach((cabin) => {
          let item = _.find(departureOrder?.cabins, {
            cabin_id: cabin?.id,
          });
          if (item) {
            cabinChecked.push(`${item?.hop_id}-${item?.cabin_id}`);
          }
        });
        setCabinsDepartureChecked(cabinChecked);
      }
      if (Array.isArray(addons)) {
        let addonChecked = [];
        addons.forEach((addon) => {
          let item = _.find(departureOrder?.addons, {
            addon_id: addon?.addon?.id,
          });
          if (item) {
            addonChecked.push(`${item?.hop_id}-${item?.addon_id}`);
          }
        });
        setAddonsDepartureChecked(addonChecked);
      }
    }
  }, []);

  useEffect(() => {
    if (searchData.length > 0) {
      // console.log('customer: ', customer);
      setDepartureSearchItems(
        searchData.map((item, index) => {
          return {
            key: item?.id,
            label: `${item?.route?.title} - ${item?.route?.operator?.title}`,
            style: {
              marginBottom: 12,
              background: '#00000005',
              borderRadius: '8px',
              border: 'none',
            },
            children: (
              <React.Fragment>
                <Row gutter={[16, 16]}>
                  <Col span={8}>
                    <Text style={{ fontWeight: 'bold' }}>
                      <IntlMessage id="global.cabins" />
                    </Text>
                  </Col>
                  <Col span={6}>
                    <Text style={{ fontWeight: 'bold' }}>
                      <IntlMessage id="global.price" />
                    </Text>
                  </Col>
                  <Col span={4}>
                    <Text style={{ fontWeight: 'bold' }}>
                      <IntlMessage id="global.qty" />
                    </Text>
                  </Col>
                  <Col span={6}>
                    <Text style={{ fontWeight: 'bold' }}>
                      <IntlMessage id="global.notes" />
                    </Text>
                  </Col>
                </Row>
                <br />
                <Checkbox.Group
                  style={{ width: '100%', flexDirection: 'column' }}
                  onChange={(value) => handleCheckedCabinDeparture(value, item)}
                  value={cabinsDepartureChecked}
                >
                  <Row gutter={[16, 16]}>
                    {item?.cabins?.map((cabin, index) => (
                      <Cabin
                        key={index}
                        hop={item}
                        cabin={cabin}
                        customer={customer}
                        checked={cabinsDepartureChecked.find(
                          (checked) => checked === `${item?.id}-${cabin?.id}`
                        )}
                      />
                    ))}
                  </Row>
                </Checkbox.Group>
                <br />
                <Text style={{ fontWeight: 'bold' }}>
                  <IntlMessage id="global.addons" />
                </Text>
                <Checkbox.Group
                  style={{
                    width: '100%',
                    flexDirection: 'column',
                    marginTop: '6px',
                  }}
                  onChange={(value) => handleCheckedAddonDeparture(value, item)}
                  value={addonsDepartureChecked}
                >
                  <Row gutter={[16, 16]}>
                    {item?.hop_addons?.map((addon, index) => (
                      <Addon
                        key={index}
                        hop={item}
                        addon={addon}
                        checked={addonsDepartureChecked.find(
                          (checked) =>
                            checked === `${item?.id}-${addon?.addon?.id}`
                        )}
                      />
                    ))}
                  </Row>
                </Checkbox.Group>
              </React.Fragment>
            ),
          };
        })
      );
    }
  }, [
    searchData,
    cabinsDepartureChecked,
    addonsDepartureChecked,
    customer,
    activeDeparture,
  ]);

  const onChangeDepartureCollapse = (key) => {
    setIsChangeActive(true);
    setActiveDeparture(key.length > 0 ? [key[key.length - 1]] : []);
  };

  const handleCheckedCabinDeparture = (value, route) => {
    // console.log('cabins checked', value);
    if (isChangeActive && currentRouteId !== route.id) {
      setAddonsDepartureChecked([]);
      setIsChangeActive(false);
    }
    setCurrentRouteId(route.id);
    setCabinsDepartureChecked(value);
  };

  const handleCheckedAddonDeparture = (value, route) => {
    // console.log('addons checked', value);
    if (isChangeActive && currentRouteId !== route.id) {
      setCabinsDepartureChecked([]);
      setIsChangeActive(false);
    }
    setCurrentRouteId(route.id);
    setAddonsDepartureChecked(value);
  };

  return (
    <React.Fragment>
      {/* <Card
        title={`Departure ${searchData[0].start_stop.title} - ${searchData[0].end_stop.title}`}
        style={{ border: 'none' }}
      >
      </Card> */}
      <Title level={5}>
        {`Departure ${searchData[0].start_stop.title} - ${
          searchData[0].end_stop.title
        } ${convertToAnyTimezone(searchValues?.date).format('DD/MM/YYYY')}`}
      </Title>
      <Collapse
        items={searchDepartureItems}
        onChange={onChangeDepartureCollapse}
        activeKey={activeDeparture}
        bordered={false}
        style={{
          background: '#ffffff',
        }}
      />
    </React.Fragment>
  );
};

const Cabin = (props) => {
  const dispatch = useDispatch();
  const departureCabins = useSelector(
    (state) => state.editOrder.departure.cabins
  );
  // states
  const { hop, customer, cabin, checked } = props;
  const [cabinPrice, setCabinPrice] = useState(
    customer?.cgroup?.discount
      ? roundToThousands(
          Number(cabin?.cabin_rates?.price) -
            (Number(cabin?.cabin_rates?.price) *
              Number(customer?.cgroup?.discount)) /
              100
        )
      : roundToThousands(Number(cabin?.cabin_rates?.price))
  );
  const [cabinQty, setCabinQty] = useState(1);

  useEffect(() => {
    const item = _.find(departureCabins, {
      hop_id: hop?.id,
      cabin_id: cabin?.id,
    });
    if (item) {
      setCabinPrice(roundToThousands(item?.price));
      setCabinQty(item?.quantity);
    }
  }, []);

  useEffect(() => {
    if (cabinQty > 0) {
      dispatch(
        updateCabinsDepartureEditOrder({
          value: {
            hop_id: hop?.id,
            cabin_id: cabin?.id,
            title: cabin?.title,
            price: roundToThousands(cabinPrice),
            quantity: cabinQty,
          },
          checked,
        })
      );
    }
  }, [checked, cabinPrice, cabinQty]);

  const handleChangePrice = (value) => {
    setCabinPrice(value);
  };

  const handleChangeQty = (value) => {
    setCabinQty(value);
  };

  return (
    <React.Fragment>
      <Col span={8}>
        <Checkbox
          value={`${hop?.id}-${cabin?.id}`}
          // disabled={cabin?.cabin_rates?.seat_available < 1}
        >
          {cabin?.title}
        </Checkbox>
      </Col>
      <Col span={6}>
        <InputNumber
          min={1}
          value={cabinPrice}
          disabled={!checked}
          onChange={handleChangePrice}
          formatter={(value) =>
            `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')
          }
          style={{ minWidth: '100px' }}
        />
        <Text> per {cabin?.price_type}</Text>
        <Text style={{ display: 'block', marginTop: '12px' }}>
          {cabin?.cabin_rates?.seat_available <= 0
            ? 0
            : cabin?.cabin_rates?.seat_available}{' '}
          available
        </Text>
      </Col>
      <Col span={4}>
        <InputNumber
          min={1}
          // max={Number(cabin?.cabin_rates?.seat_available)}
          value={cabinQty}
          disabled={!checked}
          onChange={handleChangeQty}
          formatter={(value) =>
            `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')
          }
          style={{ minWidth: 'min-content' }}
        />
      </Col>
    </React.Fragment>
  );
};

const Addon = (props) => {
  const dispatch = useDispatch();
  const departureAddons = useSelector(
    (state) => state.editOrder.departure.addons
  );
  // states
  const { hop, addon, checked } = props;
  const [addonPrice, setAddonPrice] = useState(
    roundToThousands(Number(addon?.addon?.price))
  );
  const [addonQty, setAddonQty] = useState(1);
  const [notes, setNotes] = useState('');

  // side effects
  useEffect(() => {
    const item = _.find(departureAddons, {
      hop_id: hop?.id,
      addon_id: addon?.addon?.id,
    });
    if (item) {
      setAddonPrice(roundToThousands(item?.price));
      setAddonQty(item?.quantity);
      setNotes(item?.notes);
    }
  }, []);

  useEffect(() => {
    const setNotesFuc = _.debounce(async () => {
      if (addonQty > 0) {
        dispatch(
          updateAddonsDepartureEditOrder({
            value: {
              hop_id: hop?.id,
              addon_id: addon?.addon?.id,
              title: addon?.addon?.title,
              price: roundToThousands(addonPrice),
              quantity: addonQty,
              notes,
            },
            checked,
          })
        );
      }
    }, 300);
    setNotesFuc();

    return () => {
      clearTimeout(setNotesFuc);
    };
  }, [checked, addonPrice, addonQty, notes]);

  const handleChangePrice = (value) => {
    setAddonPrice(value);
  };

  const handleChangeQty = (value) => {
    setAddonQty(value);
  };

  const handleChangeNotes = (e) => {
    setNotes(e.target.value);
  };

  return (
    <React.Fragment>
      <Col span={8}>
        <Checkbox value={`${hop?.id}-${addon?.addon?.id}`}>
          {addon?.addon?.title}
        </Checkbox>
      </Col>
      <Col span={6}>
        <InputNumber
          min={1}
          value={addonPrice}
          disabled={!checked}
          onChange={handleChangePrice}
          formatter={(value) =>
            `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')
          }
          style={{ minWidth: '100px' }}
        />
        <Text> per {addon?.addon?.type}</Text>
      </Col>
      <Col span={4}>
        <InputNumber
          min={1}
          value={addonQty}
          disabled={!checked}
          onChange={handleChangeQty}
          formatter={(value) =>
            `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')
          }
          style={{ minWidth: 'min-content' }}
        />
      </Col>
      <Col span={6}>
        <TextArea
          placeholder="Add notes"
          value={notes || ''}
          onChange={handleChangeNotes}
          disabled={!checked}
          rows={2}
        />
      </Col>
    </React.Fragment>
  );
};

export default Departure;
